import LawFirm from './LawFirm';

export default LawFirm;
